module.exports = __webpack_public_path__ + "img/weather-hail.4a6c1a71.png";